import { ContentPage } from "@/components/marketing/ContentPage";
import { LegalDraftNotice } from "@/components/marketing/LegalDraftNotice";

export function Terms() {
  return (
    <ContentPage kicker="Legal" title="Terms of Service" lastUpdated="May 25, 2026">
      <LegalDraftNotice />

      <p>
        These Terms of Service ("Terms") govern your access to and use of Social
        Media OS (the "Service"). By creating an account or using the Service,
        you agree to these Terms. If you're using the Service on behalf of an
        organization, you're agreeing on that organization's behalf.
      </p>

      <h2>1. Accounts and access</h2>
      <p>
        The Service is currently invite-only. You're responsible for the
        activity that happens under your account and for keeping your
        credentials secure. You must provide accurate account information and
        let us know promptly if you believe your account has been compromised.
      </p>

      <h2>2. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>use the Service to create or publish content that is unlawful, infringing, deceptive, or that violates a platform's own terms;</li>
        <li>attempt to access another workspace's data or otherwise circumvent the Service's access controls;</li>
        <li>probe, scan, or disrupt the integrity or performance of the Service;</li>
        <li>reverse engineer or resell the Service except as expressly permitted; or</li>
        <li>use the Service to send spam or to violate the rights of others.</li>
      </ul>
      <p>
        You are responsible for any content you generate, approve, schedule, or
        publish through the Service, including ensuring it complies with the
        rules of the platforms you publish to.
      </p>

      <h2>3. Your content</h2>
      <p>
        You retain ownership of the content and data you provide to the Service,
        including your brand information and the drafts you generate. You grant
        us a limited license to process that content solely to operate and
        provide the Service to you — for example, to generate drafts, run safety
        checks, and publish approved posts to the accounts you connect.
      </p>

      <h2>4. Third-party platforms and services</h2>
      <p>
        The Service connects to third-party platforms (such as Instagram,
        Facebook, and TikTok) and relies on third-party providers (such as AWS
        and Anthropic) to function. Your use of those platforms is also subject
        to their terms, and we aren't responsible for their availability or
        actions.
      </p>

      <h2>5. Fees</h2>
      <p>
        Paid plans, where applicable, are described on our{" "}
        <a href="/pricing">pricing page</a>. During the invite-only beta, fees
        apply only once you've been invited off the waitlist and selected a
        plan.
      </p>

      <h2>6. Termination</h2>
      <p>
        You may stop using the Service at any time. We may suspend or terminate
        access if you violate these Terms or if we reasonably believe your use
        poses a risk to the Service or other users. On termination, your right
        to use the Service ends; provisions that by their nature should survive
        (such as ownership, disclaimers, and limitations of liability) will
        survive.
      </p>

      <h2>7. Disclaimers</h2>
      <p>
        The Service is provided "as is" and "as available" without warranties of
        any kind, to the fullest extent permitted by law. Generated drafts are
        suggestions for human review — you are responsible for reviewing and
        approving content before it is published.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, we will not be liable for any
        indirect, incidental, special, consequential, or punitive damages, or
        for any loss of profits or data, arising from your use of the Service.
      </p>

      <h2>9. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. If we make material
        changes, we'll take reasonable steps to notify you. Continued use of the
        Service after changes take effect means you accept the updated Terms.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These Terms are governed by the laws of [Governing law jurisdiction to
        be determined], without regard to its conflict-of-laws rules.
      </p>

      <h2>11. Contact</h2>
      <p>
        Questions about these Terms? Email{" "}
        <a href="mailto:legal@socialmediamanager.pheonixapps.com">
          legal@socialmediamanager.pheonixapps.com
        </a>
        .
      </p>
    </ContentPage>
  );
}

export default Terms;
